// components/common/PositionDebugOverlay.tsx
import React from 'react';
import { PositionInfo } from '@/utils/dropdownPositioning';

export const PositionDebugOverlay: React.FC<{ positionInfo: PositionInfo }> = ({ positionInfo }) => {
  if (!positionInfo.debug) return null;

  const { availableSpace, triggerRect } = positionInfo.debug;

  return (
    <div className="fixed inset-0 pointer-events-none z-[10002]">
      {/* Available space indicators */}
      <div
        className="absolute bg-green-500/10 border border-green-500"
        style={{
          top: 0,
          left: triggerRect.left,
          width: triggerRect.width,
          height: availableSpace.top,
        }}
      >
        <span className="absolute top-2 left-2 text-xs text-green-700 bg-white px-1">
          Top: {Math.round(availableSpace.top)}px
        </span>
      </div>
      
      <div
        className="absolute bg-blue-500/10 border border-blue-500"
        style={{
          top: triggerRect.top,
          left: triggerRect.right,
          width: availableSpace.right,
          height: triggerRect.height,
        }}
      >
        <span className="absolute top-2 left-2 text-xs text-blue-700 bg-white px-1">
          Right: {Math.round(availableSpace.right)}px
        </span>
      </div>
      
      <div
        className="absolute bg-red-500/10 border border-red-500"
        style={{
          top: triggerRect.bottom,
          left: triggerRect.left,
          width: triggerRect.width,
          height: availableSpace.bottom,
        }}
      >
        <span className="absolute top-2 left-2 text-xs text-red-700 bg-white px-1">
          Bottom: {Math.round(availableSpace.bottom)}px
        </span>
      </div>
      
      <div
        className="absolute bg-yellow-500/10 border border-yellow-500"
        style={{
          top: triggerRect.top,
          left: 0,
          width: availableSpace.left,
          height: triggerRect.height,
        }}
      >
        <span className="absolute top-2 right-2 text-xs text-yellow-700 bg-white px-1">
          Left: {Math.round(availableSpace.left)}px
        </span>
      </div>
      
      {/* Position indicator */}
      <div className="fixed top-4 right-4 bg-white shadow-lg rounded-lg p-4 pointer-events-auto">
        <h3 className="text-sm font-semibold mb-2">Dropdown Position Debug</h3>
        <div className="space-y-1 text-xs">
          <div>Position: <span className="font-mono bg-gray-100 px-1">{positionInfo.position}</span></div>
          <div>Top: <span className="font-mono bg-gray-100 px-1">{Math.round(positionInfo.top)}px</span></div>
          <div>Left: <span className="font-mono bg-gray-100 px-1">{Math.round(positionInfo.left)}px</span></div>
          <div>Element: <span className="font-mono bg-gray-100 px-1">{positionInfo.debug.elementSize.width}x{positionInfo.debug.elementSize.height}</span></div>
        </div>
      </div>
    </div>
  );
};